<template>
    <div class="col-12 mt-1">
        <div class="card">
            <div class="card-body my-0 mx-0">
                <div class="row">
                    <div class="col-12">
                        <h4>Lista de Clientes</h4>
                    </div>
                    <div class="col-12 col-md-6 col-lg-2">
                        <div class="form-group">
                            <label class="control-label">
                                Sistemas de clientes
                            </label>
                            <el-select v-model="localStatus" placeholder="Seleccione"
                                @change="changeStatusFilter"
                            >
                                <el-option
                                    label="Todos"
                                    value="all"
                                    key="all"
                                ></el-option>
                                <el-option
                                    label="Bloqueado"
                                    value="blocked"
                                    key="blocked"
                                ></el-option>
                                <el-option
                                    label="Activo"
                                    value="active"
                                    key="active"
                                ></el-option>
                            </el-select>
                        </div>
                    </div>
                    <div class="col-12 col-md-6 col-lg-3">
                        <div class="form-group">
                            <label class="control-label">
                                Filtrar por:
                            </label>
                            <el-select
                                v-model="localFilter.column"
                                placeholder="Seleccionar"
                                @change="changeClearInput"
                            >
                                <el-option
                                    v-for="item in listOptionSearch"
                                    :key="item.id"
                                    :value="item.id"
                                    :label="item.text"
                                ></el-option>
                            </el-select>
                        </div>
                    </div>
                    <div class="col-12 col-md-6 col-lg-7">
                        <div class="form-group">
                            <label class="control-label">
                                &nbsp;
                            </label>
                            <el-input
                                v-model="localFilter.value"
                                prefix-icon="el-icon-search"
                                placeholder="Buscar..."
                                clearable
                                @input="emitFilterChange"
                            ></el-input>
                        </div>
                    </div>
                    <div class="col-12 col-lg-3 mt-2">
                        <div class="form-group">
                            <label class="control-label">
                                Seleccionados:
                                <el-tooltip content="Al enviar notificación a más de 10 seleccionados irán por segundo plano (colas)"
                                    effect="dark" placement="top"
                                >
                                    <i class="fa fa-info-circle"></i>
                                </el-tooltip>
                            </label>
                            <el-select v-model="localIdNotificationGlobal"
                                placeholder=""
                                class="mr-2"
                                @change="emitIdNotificationGlobal"
                            >
                                <el-option v-for="(notification, index) in all_notifications"
                                    :key="index"
                                    :label="notification.title"
                                    :value="notification.id"
                                ></el-option>
                            </el-select>
                        </div>
                    </div>
                    <div class="col-12 col-lg-3 mt-2">
                        <br>
                        <el-button type="primary"
                            size="mini"
                            :disabled="!has_selected"
                            :loading="loadingSubmitMassive"
                            @click.prevent="$emit('submit-message-massive')"
                        >
                            Enviar notificación a seleccionados
                        </el-button>
                    </div>
                    <div class="col-12 col-lg-3 mt-2">
                        <br>
                        <el-button type="success"
                            size="mini"
                            @click.prevent="showDialogMassive = true"
                            :loading="loadingSubmitMassiveFromExcel"
                        >
                            Enviar masivamente
                        </el-button>
                    </div>
                    <div class="col-12 responsive mt-3">
                        <div class="table-responsive">
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th></th>
                                        <th>Hostname</th>
                                        <th>Nombre</th>
                                        <th>RUC</th>
                                        <th class="text-center">Bloquear cuenta</th>
                                        <th class="text-center">Notificación</th>
                                        <th class="text-center">Acciones</th>
                                        <th class="text-center">Historial</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-if="!systems.length">
                                        <td colspan="7" class="text-center">
                                            No hay registros
                                        </td>
                                    </tr>
                                    <tr v-else v-for="system in systems" :key="system.id">
                                        <td class="text-center">
                                            <el-checkbox
                                                v-model="system.selected"
                                            ></el-checkbox>
                                        </td>
                                        <td>{{ system.hostname }}</td>
                                        <td>{{ system.name }}</td>
                                        <td>{{ system.number }}</td>
                                        <td class="text-center">
                                            <el-switch v-model="system.locked_tenant"
                                                disabled
                                            ></el-switch>
                                        </td>
                                        <td class="text-center">
                                            <el-select v-model="system.notification_id"
                                                style="width: 200px;"
                                            >
                                                <el-option v-for="(notification, index) in all_notifications"
                                                    :key="index"
                                                    :label="notification.title"
                                                    :value="notification.id"
                                                ></el-option>
                                            </el-select>
                                        </td>
                                        <td class="text-center">
                                            <el-button type="primary"
                                                size="mini"
                                                @click.prevent="$emit('submit-message', system)"
                                                :loading="system.loading"
                                            >
                                                Enviar mensaje
                                            </el-button>
                                        </td>
                                        <td class="text-center">
                                            <el-button type="primary"
                                                size="mini"
                                                @click.prevent="openModalHistory(system)"
                                            >
                                                <i class="fa fa-history"></i>
                                            </el-button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                    <div class="col-12 text-center">
                        <el-pagination
                            :total="pagination.total"
                            :current-page="pagination.current_page"
                            :page-size="pagination.per_page"
                            @current-change="page => $emit('page-change', page)"
                            layout="total, prev, pager, next"></el-pagination>
                    </div>
                </div>
            </div>
        </div>

        <ModalHistory
            :showDialog.sync="showDialog"
            :dataSystem="dataSystem"
        />
        <ModalMassive
            :showDialogMassive.sync="showDialogMassive"
            :notifications.sync="all_notifications"
            @submit-from-excel="submitFromExcel"
        />
    </div>
</template>

<script>
    import ModalHistory from './ModalHistory.vue'
    import ModalMassive from './ModalMassive.vue'

    export default {
        name: 'ListClients',
        components: {
            ModalHistory,
            ModalMassive
        },
        props: {
            systems: {
                type: Array,
                default: () => []
            },
            pagination: {
                type: Object,
                default: () => ({})
            },
            status_filter: {
                type: String,
                default: 'all'
            },
            listOptionSearch: {
                type: Array,
                default: () => []
            },
            filter: {
                type: Object,
                default: () => ({ column: 'hostname', value: null })
            },
            id_notification_global: {
                type: [String, Number, null],
                default: null
            },
            all_notifications: {
                type: Array,
                default: () => []
            },
            has_selected: {
                type: Boolean,
                default: false
            },
            loadingSubmitMassive: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                localStatus: this.status_filter,
                localFilter: {...this.filter},
                localIdNotificationGlobal: this.id_notification_global,
                showDialog: false,
                dataSystem: null,
                showDialogMassive: false,
                loadingSubmitMassiveFromExcel: false
            }
        },
        watch: {
            status_filter (current) {
                this.localStatus = current
            },
            filter: {
                handler (current) {
                    this.localFilter = {...current}
                },
                deep: true
            },
            id_notification_global (current) {
                this.localIdNotificationGlobal = current
            }
        },
        methods: {
            changeStatusFilter() {
                this.$emit('change-status-filter', this.localStatus)
            },

            changeClearInput() {
                this.localFilter.value = null
                this.emitFilterChange()
            },

            emitFilterChange() {
                this.$emit('change-filter', this.localFilter)
            },

            emitIdNotificationGlobal() {
                this.$emit('change-id-notification-global', this.localIdNotificationGlobal)
            },

            openModalHistory(system) {
                this.dataSystem = system
                this.showDialog = true
            },

            async submitFromExcel(formData) {
                try {
                    this.loadingSubmitMassiveFromExcel = true
                    const {
                        hostnames,
                        message,
                        notification_id,
                        title
                    } = formData

                    const { data } = await this.$http.post(`/notifications/send-notification-massive-from-excel`, {
                        hostnames,
                        message,
                        notification_id,
                        title
                    })
                    if (data.success) {
                        this.$message.success(data.message)
                    } else {
                        this.$message.error(data.message)
                    }
                } catch (error) {
                    console.log(error)
                } finally {
                    this.loadingSubmitMassiveFromExcel = false
                }
            }
        },
    }
</script>


// WEBPACK FOOTER //
// resources/js/views/system/notifications/partials/ListClients.vue